// 直接レイアウトファイルに埋め込む為 CDN へ配置不要
import { initChild } from "./utils/MathJaxChannel";

// 参考書（授業テキスト）のコンテンツに埋め込み外側と通信する
import { rewriteForSafari } from "./utils/browser/Workarounds";

window.addEventListener("load", () => {
  rewriteForSafari(".global--wrapper");
  initChild();
});
